import { useLocation } from '@solidjs/router';
import { createEffect, Show } from 'solid-js';
import ErrorIcon from '~/assets/images/error-icon.png';
import { BACK_TO_HOME, CONTACT_SUPPORT, OPS_SOMETHING_WENT_WRONG, TRY_AGAIN } from '~/assets/strings';
import { Button } from '~/components/common/buttons/Button';
import usePresenter from '~/framework/hooks/usePresenter';
import { useLocalization } from '~/hooks/useLocalization';
import { CompanyInfoPresenter } from '~/presenters/CompanyInfoPresenter';

export const ErrorFallback = (props: { error: Error; reset: () => void }) => {
  const { t } = useLocalization();
  const location = useLocation();

  const { model: companyInfo } = usePresenter(CompanyInfoPresenter);

  createEffect(() => {
    import.meta.env.DEV && console.error('error', props.error);
  });

  return (
    <div class="mx-auto flex min-h-dvh max-w-[600px] flex-col items-center justify-center gap-5 px-4 text-center text-xl font-semibold md:px-0">
      <img src={ErrorIcon} alt="Error icon" class="w-[300px]" />
      <p class="text-text-level03">{t(OPS_SOMETHING_WENT_WRONG)}</p>
      <div class="flex gap-3">
        <Show when={location.pathname !== '/tenants'}>
          <Button href="/tenants" variant="outlined" rounded="full">
            {t(BACK_TO_HOME)}
          </Button>
        </Show>
        <Button onClick={props.reset} variant="outlined" rounded="full">
          {t(TRY_AGAIN)}
        </Button>
        <Show when={companyInfo()?.email}>
          <a href={`mailto:${companyInfo()?.email}`}>
            <Button variant="outlined" rounded="full">
              {t(CONTACT_SUPPORT)}
            </Button>
          </a>
        </Show>
      </div>
    </div>
  );
};
